import { useState } from "react";
import Link from "next/link";
import { useTranslation } from "react-i18next";

import BlogList from "./sections/BlogList";
import BlogHero from "./sections/BlogHero";
import Newsletter from "@/my_components/Newsletters/Newsletter";
import EventCarouse from "@/my_components/Events/EventCarouse";
import CallToActionOne from "@/my_components/CallToAction/CallToActionOne";

import BlogData from "@/data/blog/blog.json";

// CONFIGS AND ROUTE
import { ROUTE } from "@/route/app_routes.js";
import { CONFIG } from "@/app_config.js";
import { image_url } from "../../helper/Utilities";
import { filterBlogPosts } from "@/helper/SpecialHelpers";




const AllBlogs = () => {

  const { t } = useTranslation("blog");
  const [search, setSearch] = useState("");
  const [activeTag, setActiveTag] = useState("All");
  const resultCount = filterBlogPosts(BlogData.blogList, search, activeTag).length;

  return (


        <main className="rbt-main-wrapper">

            <div className="rbt-page-banner-wrapper">
                <div className="rbt-banner-image"></div>
                <div className="rbt-banner-content">
                    <BlogHero
                        search={search}
                        setSearch={setSearch}
                        activeTag={activeTag}
                        setActiveTag={setActiveTag}
                        resultCount={resultCount}
                    />
                </div>
            </div>




            <div className="rbt-blog-area rbt-section-overlayping-top rbt-section-gap">
                <div className="container">
                    <BlogList isPagination={true} search={search} activeTag={activeTag} />
                </div>
            </div>






            <CallToActionOne />







            <div className="rbt-event-area rbt-section-gap bg-gradient-3">
                <div className="container">
                    <div className="row mb--55">
                        <div className="section-title text-center">
                            <span className="subtitle bg-white-opacity">
                                {t("events.eyebrow", "INTERESTED IN JOINING?")}
                            </span>
                            <h2 className="title color-white">{t("events.title", "Upcoming Events")}</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <EventCarouse />
                        </div>
                    </div>
                </div>
            </div>







            <div className="rbt-newsletter-area bg-color-primary newsletter-style-2 rbt-section-gap" 
                style={{ background: "url("+image_url('/app_images/bg/dots.png')+") repeat center/auto" }}>
                <Newsletter />
            </div>




        </main>

    );
  
};



export default AllBlogs;
